import {cashBoxViewPage} from "../../../hoc/cashBoxViewPage";

const CashIn = cashBoxViewPage('CashIn')
export default CashIn
